import { render, staticRenderFns } from "./DressageResultComponent.vue?vue&type=template&id=2f2af6f4&scoped=true"
import script from "./DressageResultComponent.vue?vue&type=script&lang=ts"
export * from "./DressageResultComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2af6f4",
  null
  
)

export default component.exports